import store from '../redux/store';
import { BehaviorSubject } from 'rxjs';
import { CLOSE_MENU_EVENT, OPEN_CART_MENU_EVENT, OPEN_USER_MENU_EVENT } from '../constants/event';
import { Menu } from '../types/menu';
import { toggleCartHeaderDropdown } from '../redux/slice/cartSlice';

export const activeMenu = new BehaviorSubject<Menu>(Menu.NONE);

export const dispatchOpenMenuEvent = (menu: Menu) => {
  switch (menu) {
    case Menu.USER_MENU:
      document.dispatchEvent(OPEN_USER_MENU_EVENT);
      break;
    case Menu.CART_MENU:
      document.dispatchEvent(OPEN_CART_MENU_EVENT);
      break;
    default:
      break;
  }
};

export const dispatchCloseMenuEvent = () => {
  document.dispatchEvent(CLOSE_MENU_EVENT);
};

export const dispatchToggleMenuEvent = (menu: Menu) => {
  const config = store.getState().cart.cartHeaderConfig;
  const open = config?.open;

  switch (menu) {
    case Menu.USER_MENU:
      if (activeMenu.getValue() !== Menu.USER_MENU) {
        document.dispatchEvent(OPEN_USER_MENU_EVENT);
      } else {
        dispatchCloseMenuEvent();
      }
      break;
    case Menu.CART_MENU:
      if (activeMenu.getValue() !== Menu.CART_MENU) {
        document.dispatchEvent(OPEN_CART_MENU_EVENT);
        store.dispatch(toggleCartHeaderDropdown({ open: !open, index: 0 }));
      } else {
        dispatchCloseMenuEvent();
      }
      break;
    default:
      break;
  }
};
